export const balanceBonus = {
  balanceBonus_title: "奖金",
  balanceBonus_statusActive: "有效",
  balanceBonus_statusUnlocked: "已解锁",
  balanceBonus_explain: "仅可用于老虎机和彩票。不可提现。",
  balanceBonus_progressLabel: "投注进度",
  balanceBonus_wageringRemaining: "再投注 {{amount}} 即可解锁您的奖金",
  balanceBonus_wageringMet: "奖金已解锁！",
  balanceBonus_expires: "到期日 {{date}}",
};

export default balanceBonus;
